import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "manageDiv",
  class: "flex-container non-scrollable side-paddings"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "form-check form-switch" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, "Režim hluboké editace", -1)
const _hoisted_5 = { class: "productGrid scrollable" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = { class: "productActions clearfix" }
const _hoisted_11 = { class: "form-check form-switch bigSwitch float-start" }
const _hoisted_12 = ["onUpdate:modelValue", "onChange"]
const _hoisted_13 = { class: "form-check-label" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

import {useProductStore} from "@/store/ProductStore"
import ProductForm from "@/components/ProductForm.vue"
import { ref } from "@vue/reactivity";
import { Product } from "@/types/Product";
import Modal from "@/components/Modal.vue";
import { ModalResult } from "@/types/ModalResult";


export default /*#__PURE__*/_defineComponent({
  __name: 'Manage',
  setup(__props) {


const isDeepEditing = ref(false);


const productForm = ref<InstanceType<typeof ProductForm>>();

const productStore = useProductStore();
productStore.getProducts();

function selectProduct(product: Product){
    productForm.value?.update(product);
}
function createNew(){
    productForm.value?.createNew();
}

async function changeTheSwitch(e:Event, product: Product){
    const checkBox = e.target as HTMLInputElement;
    checkBox.disabled = true;
    await productStore.toggleIsAvailable(product.id);
    checkBox.disabled = false;
}

const deleteDialog = ref<InstanceType<typeof Modal>>();
const productDeleteName = ref("");
async function deleteProduct(product: Product){
    productDeleteName.value = product.name;
    const res = await deleteDialog.value?.showAsync();
    if(res == ModalResult.Button2){
        productStore.deleteProduct(product.id);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: createNew,
          class: "btn btn-primary"
        }, "Přidat"),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            role: "switch",
            id: "flexSwitchCheckDefault",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isDeepEditing) ? (isDeepEditing).value = $event : null))
          }, null, 512), [
            [_vModelCheckbox, _unref(isDeepEditing)]
          ]),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            key: product.id,
            class: "card"
          }, [
            _createElementVNode("img", {
              class: "card-img-top",
              height: "140",
              src: product.imageUrl
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h5", _hoisted_8, _toDisplayString(product.name), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(product.price.toFixed(2)) + " Kč", 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    "onUpdate:modelValue": ($event: any) => ((product.isAvailable) = $event),
                    onChange: ($event: any) => (changeTheSwitch($event, product))
                  }, null, 40, _hoisted_12), [
                    [_vModelCheckbox, product.isAvailable]
                  ]),
                  _createElementVNode("label", _hoisted_13, _toDisplayString(product.isAvailable?'Dostupný':'Nedostupný'), 1)
                ]),
                (_unref(isDeepEditing))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-outline-danger float-end",
                      onClick: ($event: any) => (deleteProduct(product))
                    }, _hoisted_16, 8, _hoisted_14))
                  : _createCommentVNode("", true),
                (_unref(isDeepEditing))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-outline-primary me-2 float-end",
                      onClick: ($event: any) => (selectProduct(product))
                    }, _hoisted_19, 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(ProductForm, {
      ref_key: "productForm",
      ref: productForm
    }, null, 512),
    _createVNode(Modal, {
      ref_key: "deleteDialog",
      ref: deleteDialog,
      title: "Odstranit produkt?",
      message: 'Opravdu chcete odstranit produkt '+_unref(productDeleteName),
      button1msg: "Ponechat",
      button2msg: "Odstranit"
    }, null, 8, ["message"])
  ], 64))
}
}

})